/*
 * @Description: 心智占有率-物流行业表现与对比
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-20 16:03:00
 * @LastEditTime: 2020-06-28 15:53:06
 */


const group = (name, value) => {
  
  const title = {
    type: 'text',
    left: 'center',
    top: '50%',
    z: 100,
    style: {
      text: name,
      fill: '#eead81',
      font: '22px "STHeiti", sans-serif'
    }
  };

  const num = {
    type: 'text',
    left: 'center',
    top: '80%',
    z: 100,
    style: {
      text: value,
      fill: '#eead81',
      font: '22px "STHeiti", sans-serif'
    }
  };
  
  return {
    type: 'group',
    left: 'center',
    top: 'center',
    width: 135,
    height: 135,
    z: 100,
    children: [ title, num ]
  }
};


const calcPercent = (num, count) => Math.round(num / count * 10000) / 100;


// webpack:///./~/echarts/lib/util/number.js ^ 219行计算百分比
// echart 采用向下取整，如果百分比相加不能得到百分百将补全差值

export default (data, query) => {
  const brand = query.brandName;

  var itemStyle = {
    normal: {
      opacity: 0.7,

      borderWidth: 1,
      borderColor: '#000'
    }
  };

  const dataList = data.chartsJson || [{
    items: [],
    tableData: [],
    highlight: {}
  }];


  let qopData = dataList[0].items;

  var mmData = []
  var legendData = []
  let countAll = 0;
  function makeData(qopData) {

    for (var i = 0; i < qopData.length; i++) {
      var ss = qopData[i].grayColor
        ? '#44548f'
        : '#ffd70d';
      countAll += Math.abs(qopData[i].value);
      mmData.push({
        value: qopData[i].value,
        name: qopData[i].name,
        itemStyle: {
          normal: {
            color: ss
          }
        }
      })
      legendData.push(qopData[i].name)
    }

    return { mmData: mmData, legendData: legendData }
  }


  qopData.sort((a, b) => {
    let prev = a.industry_mind.replace('%', '') - 0
    let next = b.industry_mind.replace('%', '') - 0
    return next - prev
  })

  makeData(qopData)

  const summary = dataList[0].highlight;

  const brandInfo = mmData.find(item => {
    return item.name === brand;
  });

  // console.log(qopData, mmData);

  
  let title = `心智占有率 - ${summary.brandName}`

  if (summary.industry) {
    title = `心智占有率 - ${summary.industry} - ${summary.brandName}`
  }

  return {
    title: {
      text: title,
      subtext: '数据来源：数字品牌榜',
      x: '20'
    },
    color: ['#ffd70d'],
    graphic: [
      {
        type: 'rect',
        z: 80,
        left: '20',
        top: '60',
        shape: {
          width: 230,
          height: 44
        },
        style: {
          fill: '#ffd70d',
          stroke: '#999'
        }
      }, {
        type: 'text',
        left: '20',
        top: 65,
        z: 100,
        style: {
          text: ' ● 阴影区颜色为黄色，表明好感度为正值；',
          stroke: '#ffd70d',
          font: '12px "STHeiti", sans-serif'
        }
      }, {
        type: 'text',
        left: '30',
        top: 85,
        z: 100,
        style: {
          text: ' 若为蓝色，表明好感度为负值。',
          stroke: '#44548f',
          font: '12px "STHeiti", sans-serif'
        }
      },
      group(brandInfo.name, calcPercent(brandInfo.value, countAll) + '%')
    ],
    legend: {
      // type: 'scroll',
      itemGap: mmData.length > 15 ? 5 : 10,
      orient: 'vertical',
      padding: 20,
      top: '20',
      right: '10',
      bottom: '20',
      y: 'bottom',
      data: legendData,
      inactiveColor: '#ccc'
    },
    calculable: true,
    series: [
      {
        name: '心智占有率',
        type: 'pie',
        radius: [
          '30%', '80%'
        ],
        center: [
          '50%', '50%'
        ],
        startAngle: 90,
        roseType: 'area',
        avoidLabelOverlap: true,
        label: {
          normal: {
            // formatter: `{b|{b}} {per|{d}%}`,
            formatter: (item) => {
              // `{b|{b}} {per|{d}%}`
              return `{b|${item.name}} {per|${calcPercent(item.value, countAll)}%}`;
            },
            backgroundColor: '#f2f2f2',
            borderColor: '#aaa',
            borderRadius: 4,
            padding: [
              0, 0
            ],
            rich: {
              a: {
                color: '#999',
                lineHeight: 22,
                align: 'center'
              },
              hr: {
                borderColor: '#aaa',
                width: '100%',
                borderWidth: 0.5,
                height: 0
              },
              b: {
                fontSize: 14,
                lineHeight: 25,
                color: '#333',
                align: 'center'
              },
              per: {
                color: '#eee',
                backgroundColor: '#334455',
                align: 'center',
                padding: [
                  2, 4
                ],
                borderRadius: 2,
                fontSize: 14,
              }
            }
          },
          emphasis: {
            show: true
          }

        },
        lableLine: {
          normal: {
            show: true
          },
          emphasis: {
            show: true
          }
        },
        data: mmData, //.sort((a, b) => b.value - a.value),
        itemStyle: itemStyle
      }

    ]
  };
};


// WEBPACK FOOTER //
// src/chart/shareOfMind.js